import { Grid, IconButton, TextField, makeStyles } from '@material-ui/core'
import { mdiMap, mdiMessageQuestion } from '@mdi/js'
import Icon from '@mdi/react'
import React, { useState } from 'react'

import colors from '../../../../assets/colors'
import { useLabel } from '../../../../hooks/useLabel'
import { extractCoordinatesFromGoogleMapsLink } from '../../../../util/map-utils'

import { HelperModal } from './HelperModal'
import { MapModal } from './MapModal'

const useStyles = makeStyles({
  btnMap: {
    color: '#FFFF',
    fontSize: '14px',
    backgroundColor: colors.primary,
    borderRadius: '10px',
    padding: '4px 12px',
    transition: 'all .4s ease-in-out',
    '&:hover': {
      opacity: 0.6,
      backgroundColor: colors.primary,
    },
  },
})

// Link do Google Maps, lat/lng e mapa. onChange recebe { coordinates }.
// O link não é gravado no form: só serve para extrair as coordenadas
const CoordinatesSection = ({ value, onChange }) => {
  const classes = useStyles()
  const label = useLabel()

  const [openHelper, setOpenHelper] = useState(false)
  const [openMap, setOpenMap] = useState(false)

  const lat = value?.coordinates?.lat
  const lng = value?.coordinates?.lng

  const handleChangeLink = e => {
    const link = e.target.value

    onChange({
      coordinates: link
        ? extractCoordinatesFromGoogleMapsLink(link)
        : { lat: '', lng: '' },
    })
  }

  return (
    <>
      <Grid container spacing={2} style={{ marginTop: '1em' }}>
        <Grid item xs={12} sm={8} lg={6}>
          <TextField
            type="text"
            label={label('location_link', 'Link de coordenada')}
            fullWidth
            value={value?.link}
            onChange={handleChangeLink}
            helperText="Ex: https://maps.google.com/?q=-19.954700,-43.967182"
            InputProps={{
              endAdornment: (
                <IconButton
                  size="small"
                  onClick={() => setOpenHelper(!openHelper)}
                  title="Como obter o link"
                >
                  <Icon
                    path={mdiMessageQuestion}
                    size={0.8}
                    color={colors.secondary}
                  />
                </IconButton>
              ),
            }}
          />
        </Grid>
        <Grid item xs={6} sm={2} lg={2}>
          <TextField
            type="text"
            label={label('latitude', 'Latitude')}
            disabled
            fullWidth
            value={lat || ''}
          />
        </Grid>
        <Grid item xs={6} sm={2} lg={2}>
          <TextField
            type="text"
            label={label('longitude', 'Longitude')}
            disabled
            fullWidth
            value={lng || ''}
          />
        </Grid>

        {lat && lng ? (
          <Grid
            item
            xs={12}
            lg={2}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
            }}
          >
            <IconButton
              className={classes.btnMap}
              onClick={() => setOpenMap(!openMap)}
            >
              <Icon path={mdiMap} size={1} />
              Visualizar no mapa
            </IconButton>
          </Grid>
        ) : (
          ''
        )}
      </Grid>

      <HelperModal
        open={openHelper}
        handleOpen={() => setOpenHelper(!openHelper)}
      />

      <MapModal
        open={openMap}
        handleOpen={() => setOpenMap(!openMap)}
        lat={lat || 0}
        lng={lng || 0}
        onChangePosition={(newLat, newLng) =>
          onChange({ coordinates: { lat: newLat, lng: newLng } })
        }
      />
    </>
  )
}

export default CoordinatesSection
